import * as React from "react";
import type { SVGProps } from "react";
const SvgLineChartDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 2.4v19.2h19.2M7.2 6l4.2 4.2 3-3 6.6 6.6m-4.49.6h5.09V9.309"
    />
  </svg>
);
export default SvgLineChartDown01;
